const state = {
    filterTabs: [],
    isRequesting: false,
    currentTab: null,
}

export default state